<template>
    <div>
        <div>
            <Table :columns="tblColumns" :data="tblData" size="small" :loading="isLoading" class="requestsList" />
        </div>
        <Page
            :total="totalCount"
            :current="currentPage"
            :page-size="limit"
            class="pagination"
            @on-change="handleOnpageChanged"
        />
        <ViewRequestModal ref="ViewRequest" @create="handleReloadList" />
        <CreateCoeModal ref="CreateCoeModal" @create="handleReloadList" />
        <DeleteRequestModal ref="DeleteRequest" @create="handleReloadList" />
        <DeleteRequestModal ref="RejectRequest" @create="handleReloadList" />
    </div>
</template>

<script>
import moment from 'moment';
import ViewRequestModal from '@/components/Requests/Dev/COE/ViewCoEModal.vue';
import DeleteRequestModal from '@/components/Requests/Dev/COE/DeleteCoEModal.vue';
import CreateCoeModal from '@/components/Requests/Dev/COE/CreateCoeModal.vue';
export default {
    components: {
        ViewRequestModal,
        CreateCoeModal,
        DeleteRequestModal,
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        requestsDataList: {
            type: Array,
            default: () => [],
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        totalCount: {
            type: Number,
            default: 0,
        },
        limit: {
            type: Number,
            default: 0,
        },
        totalPerPage: {
            type: Object,
            default: () => {},
        },
        // eslint-disable-next-line vue/require-default-prop
        userType: {
            type: String,
        },
    },

    data() {
        return {
            tblColumns: [
                {
                    title: 'Date',
                    key: 'createdAt',
                    width: 100,
                    render: (h, params) => {
                        return h('div', moment(params.row.createdAt).utc().format('YYYY-MM-DD'));
                    },
                },
                ...((this.userType === 'admin' && [
                    {
                        title: 'Name',
                        key: 'Name',
                        width: 250,
                        render: (h, params) => {
                            return h('div', params.row.user.name);
                        },
                    },
                ]) ||
                    []),
                {
                    title: 'Coe Type',
                    key: 'coeTYpe',
                    //fixed: 'left',
                    width: 180,
                    render: (h, params) => {
                        return h('div', params.row.requestedData.type);
                    },
                },
                {
                    title: 'Status',
                    key: 'status',
                    render: (h, params) => {
                        // return h('div', params.row.status);
                        const status = params.row.status;
                        let label = '',
                            className = 'statusLabel';
                        const upperCaseStats = status.toString().toUpperCase();
                        switch (status.toString().trim()) {
                            case 'pending':
                                label = upperCaseStats;
                                className = `${className} warning`;
                                break;
                            case 'rejected':
                                label = upperCaseStats;
                                className = `${className} danger`;
                                break;
                            case 'approved':
                                label = upperCaseStats;
                                className = `${className} success`;
                                break;
                            case 'cancelled':
                                label = upperCaseStats;
                                className = `${className} danger`;
                                break;

                            default:
                                break;
                        }
                        return h(
                            'div',
                            {
                                class: `${className}`,
                            },
                            label
                        );
                    },
                },
                {
                    title: 'Actions',
                    width: 300,
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h('Tooltip', { props: { placement: 'top', content: 'View' } }, [
                                h(
                                    'Button',
                                    {
                                        class: 'pt-btn-3',
                                    },
                                    [
                                        h('Icon', {
                                            props: {
                                                type: 'md-eye',
                                                size: '25',
                                            },
                                            on: {
                                                click: () => {
                                                    this.$emit('view', params.row);
                                                    // this.$refs.ViewRequest.openModal(params.row, false);
                                                    // console.log(params.row);
                                                },
                                            },
                                        }),
                                    ],
                                    'view'
                                ),
                            ]),
                            h('Tooltip', { props: { placement: 'top', content: 'Edit' } }, [
                                h(
                                    'Button',
                                    {
                                        class: `${
                                            params.row.status &&
                                            params.row.status.includes('pending') &&
                                            this.userType !== 'admin'
                                                ? 'pt-btn-6'
                                                : 'pt-btn-6 btn-disable'
                                        }`,
                                    },
                                    [
                                        h('Icon', {
                                            props: {
                                                type: 'md-create',
                                                size: '25',
                                            },
                                            on: {
                                                click: () => {
                                                    // this.$refs.UpdateRequest.openModal(params.row, false);
                                                    this.$refs.CreateCoeModal.openModalForEditing(params.row);

                                                    console.log(params.row);
                                                },
                                            },
                                        }),
                                    ],
                                    'edit'
                                ),
                            ]),
                            h('Tooltip', { props: { placement: 'top', content: 'Delete' } }, [
                                h(
                                    'Button',
                                    {
                                        class: `${
                                            params.row.status && params.row.status.includes('pending')
                                                ? 'pt-btn-1'
                                                : 'pt-btn-1 btn-disable'
                                        }`,
                                    },
                                    [
                                        h('Icon', {
                                            props: {
                                                type: 'md-trash',
                                                size: '25',
                                            },
                                            on: {
                                                click: () => {
                                                    console.log('userTYpe: ', this.userType);
                                                    if (this.userType === 'admin') {
                                                        this.$refs.RejectRequest.openModal(params.row, 'reject');
                                                    } else {
                                                        this.$refs.DeleteRequest.openModal(params.row, 'cancel');
                                                    }
                                                },
                                            },
                                        }),
                                    ],
                                    'delete'
                                ),
                            ]),
                        ]);
                    },
                },
            ],
            tblData: [],
        };
    },

    watch: {
        requestsDataList(data) {
            this.tblData = data;
        },
        totalPerPage(total) {
            const arrTotal = [];
            arrTotal.push(total);
        },
    },
    methods: {
        handleReloadList() {
            this.$emit('reload');
        },
        handleOnpageChanged(page) {
            this.$emit('on-page-change', page);
        },
    },
};
</script>

<style lang="scss">
ul.pagination.ivu-page {
    text-align: end;
}
.adminRequestsList button {
    width: 25px;
    margin-left: 10px;
}
.adminRequestsList i.ivu-icon {
    margin-left: -12.5px;
}
.btn-hide {
    display: none;
}
.statusLabel {
    display: inline-block;
    color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 5px -1px rgba(0, 0, 0, 0.2);
    vertical-align: middle;
    max-width: 250px;
    padding: 5px;
    text-align: center;
}
.success {
    background: #49e97e;
    font-weight: bold;
}
.warning {
    background: #ffc107;
    font-weight: bold;
}
.danger {
    background: #e9495d;
    font-weight: bold;
}
.primary {
    background: #211841;
}
.secondary {
    background: #828899;
}
</style>
